// Localized content (EN / RU / TR) for the Istanbul "Flower Delivery to Hotels" landing page.
// Natural, native-sounding copy per language (not machine translation). Facts use ONLY
// existing YUCCA data: same-day delivery, USD prices, card/crypto/transfer payments,
// RU/EN/TR support, real Istanbul districts, reception/concierge hand-over, photo before delivery.

// Curated real Istanbul product IDs (order preserved) shown in the catalog block.
export const ISTANBUL_HOTEL_PRODUCT_IDS = [
  "c40fd498-e734-40d6-aa0a-9f0daba58e51", // Тайна Сердец $102
  "ba6815f1-212d-4da8-b266-42f381dcaf43", // Запретный плод $114
  "a4964c38-37fe-454d-949e-7a2e6fd6419f", // Восторг и признание $145
  "8452f83a-adf5-4368-a74b-2b81c71fe285", // Голубая Лагуна $255
  "d8abdba7-32d9-4160-ac1b-b4b6b8e923ca", // Красный Бархат $329
  "44b5168a-4714-4a97-b5e6-3cb4efb11668", // Композиция Аристократ $555
  "8d75f1e5-beaf-4231-b051-eeeef77aebe5", // 101 Роза $707
  "7aa9951f-502f-4bcf-9a52-81db56ef6dca", // Королевский Бал $1235
];

const related = {
  ru: [
    { label: "Доставка цветов в Стамбуле", href: "/istanbul" },
    { label: "Цветы в Бешикташ", href: "/istanbul/besiktas" },
    { label: "Цветы в Шишли", href: "/istanbul/sisli" },
    { label: "Цветы в Кадыкёй (азиатская сторона)", href: "/istanbul/kadikoy" },
    { label: "Как заказать цветы в Стамбуле", href: "/blog/kak-zakazat-tsvety-v-stambule" },
    { label: "Цветы на день рождения в Стамбуле", href: "/blog/cvety-na-den-rozhdeniya-stambul" },
    { label: "Свадебные цветы в Стамбуле", href: "/blog/svadebnye-cvety-stambul" },
    { label: "Букеты в Стамбуле — гид", href: "/blog/bukety-v-stambule" },
  ],
  en: [
    { label: "Flower delivery in Istanbul", href: "/istanbul?lang=en" },
    { label: "Flowers in Beşiktaş", href: "/istanbul/besiktas?lang=en" },
    { label: "Flowers in Şişli", href: "/istanbul/sisli?lang=en" },
    { label: "Flowers in Kadıköy (Asian side)", href: "/istanbul/kadikoy?lang=en" },
    { label: "How to order flowers in Istanbul", href: "/blog/kak-zakazat-tsvety-v-stambule?lang=en" },
    { label: "Birthday flowers in Istanbul", href: "/blog/cvety-na-den-rozhdeniya-stambul?lang=en" },
    { label: "Wedding flowers in Istanbul", href: "/blog/svadebnye-cvety-stambul?lang=en" },
    { label: "Bouquets in Istanbul — guide", href: "/blog/bukety-v-stambule?lang=en" },
  ],
  tr: [
    { label: "İstanbul çiçek teslimatı", href: "/istanbul?lang=tr" },
    { label: "Beşiktaş çiçek", href: "/istanbul/besiktas?lang=tr" },
    { label: "Şişli çiçek", href: "/istanbul/sisli?lang=tr" },
    { label: "Kadıköy çiçek (Anadolu yakası)", href: "/istanbul/kadikoy?lang=tr" },
    { label: "İstanbul'da çiçek nasıl sipariş edilir", href: "/blog/kak-zakazat-tsvety-v-stambule?lang=tr" },
    { label: "İstanbul'da doğum günü çiçekleri", href: "/blog/cvety-na-den-rozhdeniya-stambul?lang=tr" },
    { label: "İstanbul'da düğün çiçekleri", href: "/blog/svadebnye-cvety-stambul?lang=tr" },
    { label: "İstanbul'da buketler — rehber", href: "/blog/bukety-v-stambule?lang=tr" },
  ],
};

export const istanbulHotelContent = {
  ru: {
    metaTitle: "Доставка цветов в отели Стамбула — заказ из любой страны | YUCCA",
    metaDescription: "Доставка цветов в отель в Стамбуле: в тот же день, вручение через ресепшен или консьержа, заказ из другой страны. Букеты в USD. Укажите отель, имя гостя и дату — пришлём фото перед доставкой.",
    h1: "Доставка цветов в отели Стамбула",
    heroLead: "Можно ли отправить цветы человеку, который живёт в отеле в Стамбуле? Да. Мы принимаем заказы из любой страны, доставляем в тот же день и передаём букет через ресепшен или консьержа. Для заказа достаточно названия отеля, имени гостя и даты доставки.",
    heroBullets: [
      "Доставка в отель — в тот же день (при своевременном заказе)",
      "Заказ из другой страны: оплата картой, криптовалютой или переводом",
      "Вручение через ресепшен/консьержа; фото букета перед доставкой",
      "Нужно: отель, имя гостя, дата (номер комнаты — по желанию)",
    ],
    cta: "Заказать цветы",
    catalogHeading: "Букеты для доставки в отель — реальные цены",
    catalogNote: "Нажмите на букет, чтобы открыть его в каталоге. Цены в долларах США.",
    fullCatalog: "Смотреть весь каталог — доставка цветов в Стамбуле",
    sections: [
      {
        h2: "Как работает доставка цветов в отель в Стамбуле",
        answer: "Процесс простой: вы выбираете букет, указываете отель и гостя, а мы согласуем вручение с ресепшеном.",
        steps: [
          "Выберите букет в каталоге или опишите идею в WhatsApp.",
          "Укажите название отеля в Стамбуле.",
          "Укажите имя гостя, на которого оформлено проживание.",
          "Выберите дату и удобное время доставки.",
          "Флористы собирают букет и присылают вам фото перед отправкой.",
          "Курьер передаёт букет в отель — через ресепшен, консьержа или лично гостю.",
        ],
      },
      {
        h2: "Какие данные нужны для заказа",
        answer: "Чем точнее данные, тем надёжнее вручение. Минимум — отель, имя гостя и дата.",
        bullets: [
          "Название отеля",
          "Имя гостя (полностью, как при заселении)",
          "Номер комнаты — если известен",
          "Дата доставки",
          "Желаемое время доставки",
          "Телефон получателя",
          "Текст открытки",
        ],
        note: "Если номер комнаты неизвестен — ничего страшного: букет передаётся через ресепшен по имени гостя. Телефон получателя помогает курьеру согласовать вручение.",
      },
      {
        h2: "Можно ли доставить цветы прямо в номер?",
        answer: "Это зависит от правил конкретного отеля. Чаще всего букет передают на ресепшен или консьержу, а гостю сообщают о доставке.",
        paras: [
          "Многие отели по соображениям безопасности не пропускают курьеров на этажи. В таких случаях цветы принимает ресепшен или консьерж и доставляет их в номер силами персонала либо вручает гостю при обращении.",
          "Если для вас важно вручение лично в руки, укажите телефон получателя — курьер сможет связаться и договориться о встрече в лобби.",
        ],
      },
      {
        h2: "Можно ли отправить цветы до заселения гостя?",
        answer: "Да. Букет можно приурочить к дате заезда, чтобы он ждал гостя к моменту check-in.",
        paras: [
          "Укажите дату заезда и название отеля. Мы согласуем с ресепшеном, чтобы букет приняли и передали гостю при заселении.",
          "Учтите, что до фактического check-in отель хранит букет на ресепшене — лучше выбирать стойкие композиции и указывать телефон гостя на случай изменения времени заезда.",
        ],
      },
      {
        h2: "Можно ли заказать цветы в Стамбул из другой страны?",
        answer: "Да. Заказ оформляется онлайн или в WhatsApp из любой страны, оплата — картой, криптовалютой или переводом.",
        paras: [
          "Мы общаемся на русском, английском и турецком, поэтому оформить заказ удобно, где бы вы ни находились. Цены указаны в долларах США.",
          "Перед вручением мы присылаем фото готового букета, а после доставки — подтверждение. Так вы контролируете сюрприз на расстоянии.",
        ],
      },
      {
        h2: "Доставка цветов в отель в тот же день",
        answer: "Доставка в тот же день доступна при своевременном заказе. Точное время зависит от района, трафика и загрузки в праздники.",
        paras: [
          "Стамбул — большой город с плотным движением, а европейская и азиатская стороны разделены Босфором. Поэтому в часы пик и в праздничные даты закладывайте запас времени.",
          "Чтобы букет приехал к нужному моменту (ужин, заезд, годовщина), оформляйте заказ заранее и указывайте желаемый интервал доставки.",
        ],
      },
      {
        h2: "Районы доставки в отели Стамбула",
        answer: "Мы доставляем в отели по обеим сторонам Босфора — на европейской и азиатской стороне.",
        table: {
          head: ["Район", "Сторона", "Информация о доставке"],
          rows: [
            ["Бешикташ", "Европейская", "Отели у Босфора и деловой центр — доставка в тот же день"],
            ["Шишли", "Европейская", "Нишанташи, бизнес- и торговые районы — доставка в тот же день"],
            ["Бейоглу", "Европейская", "Таксим, Галата, отели центра — доставка в тот же день"],
            ["Султанахмет", "Европейская", "Исторический центр, туристические отели — доставка в тот же день"],
            ["Сарыер", "Европейская", "Север у Босфора — время доставки уточняется по адресу"],
            ["Кадыкёй", "Азиатская", "Отели азиатской стороны — доставка в тот же день"],
            ["Юскюдар", "Азиатская", "Побережье азиатской стороны — время доставки уточняется по адресу"],
          ],
        },
        note: "Не нашли свой отель или район? Напишите адрес в WhatsApp — подтвердим доставку до оформления заказа.",
      },
      {
        h2: "Отели Стамбула: районы и категории",
        answer: "Отели Стамбула сосредоточены в нескольких зонах — это удобно для планирования доставки.",
        paras: [
          "На европейской стороне это деловой Бешикташ и Левент, престижный Нишанташи (Шишли), центр вокруг Таксима и Галаты (Бейоглу) и туристический Султанахмет. На азиатской стороне — оживлённый Кадыкёй и прибрежный Юскюдар.",
          "Мы доставляем в отели всех категорий — от городских бутик-отелей до крупных сетевых комплексов и люксовых отелей у Босфора. Укажите точное название отеля при заказе.",
        ],
      },
      {
        h2: "Доставка цветов в люксовые отели Стамбула",
        answer: "Для особых поводов подойдут премиальные букеты и статусные композиции из нашего каталога.",
        paras: [
          "Романтический сюрприз, годовщина, медовый месяц, предложение руки и сердца или VIP-подарок — для таких случаев мы собираем премиальные букеты, в том числе композиции из 101 розы и авторские работы.",
          "Добавьте открытку с текстом, а по желанию — попросите фото момента вручения (по возможности и правилам отеля).",
        ],
      },
      {
        h2: "Какие цветы выбрать для разных поводов",
        answer: "Ниже — простые ориентиры по поводам и подходящим букетам.",
        table: {
          head: ["Повод", "Рекомендуемые цветы", "Тип букета"],
          rows: [
            ["День рождения", "Яркие смешанные, розы", "Средний авторский букет"],
            ["Годовщина", "Красные розы", "Средний или премиум"],
            ["Медовый месяц", "Розы, пионовидные сорта", "Премиум-композиция"],
            ["Предложение руки и сердца", "101 роза, красные розы", "Премиум"],
            ["Романтический сюрприз", "Розы пастельных тонов", "Средний"],
            ["Поздравление", "Смешанные яркие", "Стандарт/средний"],
            ["Приветственный подарок", "Нежные светлые тона", "Стандарт/средний"],
            ["Деловой подарок", "Элегантные однотонные, лилии", "Средний/премиум"],
            ["Благодарность", "Светлые смешанные", "Стандарт/средний"],
          ],
        },
      },
      {
        h2: "Сколько стоит доставка цветов в отель в Стамбуле",
        answer: "Цены зависят от размера и состава букета. Ниже — реальные примеры из каталога (в долларах США).",
        table: {
          head: ["Букет", "Цена", "Для чего подходит"],
          rows: [
            ["Тайна Сердец", "$102", "Знак внимания, приветственный букет"],
            ["Голубая Лагуна", "$255", "День рождения, поздравление"],
            ["Красный Бархат", "$329", "Годовщина, романтика"],
            ["Композиция Аристократ", "$555", "Статусный подарок"],
            ["101 Роза", "$707", "Предложение, особый повод"],
            ["Королевский Бал", "$1235", "VIP-сюрприз, люкс-отель"],
          ],
        },
        note: "Полный ассортимент и актуальные цены — в каталоге Стамбула.",
      },
      {
        h2: "Что делать, если гостя нет на месте",
        answer: "Если гость недоступен, букет обычно принимает ресепшен или консьерж и передаёт его гостю.",
        paras: [
          "Поэтому мы рекомендуем указывать телефон получателя и, по возможности, предупреждать отель о доставке. Курьер и ресепшен согласуют момент передачи.",
          "Если возникнут сложности с вручением, мы свяжемся с вами, чтобы уточнить дальнейшие действия.",
        ],
      },
      {
        h2: "Советы по отправке цветов в отель Стамбула",
        answer: "Несколько практичных рекомендаций, чтобы доставка прошла гладко.",
        bullets: [
          "Указывайте полное имя гостя — так, как оно записано при заселении.",
          "Пишите точное название отеля (в Стамбуле бывают похожие названия).",
          "Указывайте дату доставки и желаемое время.",
          "Если знаете номер комнаты — добавьте его.",
          "Оставляйте телефон получателя для согласования вручения.",
          "Если это сюрприз — решите заранее, предупреждать ли отель.",
          "Учитывайте время check-in и check-out.",
          "Планируйте заранее в выходные и праздники.",
          "Добавляйте открытку с личным сообщением.",
          "Для азиатской и европейской сторон закладывайте время на трафик.",
        ],
      },
    ],
    faqTitle: "Частые вопросы",
    faq: [
      { q: "Можно ли отправить цветы в отель в Стамбуле?", a: "Да. Укажите название отеля и имя гостя — мы согласуем вручение с ресепшеном или консьержем." },
      { q: "Можно ли доставить цветы прямо в номер?", a: "Это зависит от правил отеля. Обычно букет передают на ресепшен или консьержу, которые доставляют его гостю." },
      { q: "Можно ли заказать цветы из другой страны?", a: "Да. Заказ оформляется онлайн или в WhatsApp из любой страны, оплата — картой, криптовалютой или переводом." },
      { q: "Нужен ли номер комнаты?", a: "Не обязательно. Достаточно имени гостя — букет передадут через ресепшен. Номер комнаты, если известен, ускоряет вручение." },
      { q: "Могут ли цветы приехать до заселения?", a: "Да. Букет можно приурочить к дате заезда, чтобы он ждал гостя при check-in." },
      { q: "Есть ли доставка в тот же день?", a: "Да, при своевременном заказе. Время зависит от района, трафика и праздников." },
      { q: "Можно ли передать цветы на ресепшен?", a: "Да, это самый частый сценарий вручения в отелях." },
      { q: "Можно ли отправить букет анонимно?", a: "Да, мы доставим букет, не раскрывая отправителя, и добавим открытку с вашим текстом." },
      { q: "Можно ли добавить личное сообщение?", a: "Да, приложим открытку с вашим текстом к букету." },
      { q: "Можно ли выбрать время доставки?", a: "Да, укажите желаемый интервал — мы постараемся доставить к нему." },
      { q: "Что если гостя нет на месте?", a: "Букет обычно принимает ресепшен или консьерж. Телефон получателя помогает согласовать вручение." },
      { q: "Можно ли отправить цветы в люксовый отель?", a: "Да. Для особых поводов подойдут премиальные букеты, включая композиции из 101 розы." },
      { q: "Доставляете ли на азиатскую сторону Стамбула?", a: "Да, доставляем в отели азиатской стороны — Кадыкёй, Юскюдар и другие районы." },
      { q: "Доставляете ли на европейскую сторону?", a: "Да — Бешикташ, Шишли, Бейоглу, Султанахмет, Сарыер и другие районы." },
      { q: "Сколько стоит доставка цветов в отель?", a: "Зависит от букета. Примеры из каталога: от $102 за компактный букет до премиум-композиций. Цены в долларах США." },
      { q: "Пришлёте ли фото букета перед доставкой?", a: "Да, всегда присылаем фото готовой композиции до отправки, а после — подтверждение вручения." },
    ],
    glanceTitle: "Коротко: доставка в отели Стамбула",
    glance: [
      { label: "Районы доставки", value: "Европейская и азиатская стороны" },
      { label: "В тот же день", value: "Да, при своевременном заказе" },
      { label: "Заказ из-за границы", value: "Да, из любой страны" },
      { label: "Вручение", value: "Через ресепшен или консьержа" },
      { label: "Типы букетов", value: "От компактных до премиум (101 роза)" },
      { label: "Оплата", value: "Карта, криптовалюта, перевод" },
      { label: "Языки", value: "Русский, английский, турецкий" },
      { label: "Открытка и фото", value: "Личное сообщение + фото перед доставкой" },
    ],
    relatedTitle: "Похожие услуги доставки цветов",
    related: related.ru,
    breadcrumb: { home: "YUCCA Flowers", city: "Стамбул", current: "Доставка в отели" },
  },

  en: {
    metaTitle: "Flower Delivery to Hotels in Istanbul — Order From Abroad | YUCCA",
    metaDescription: "Flower delivery to a hotel in Istanbul: same-day, hand-over via reception or concierge, ordering from another country. Prices in USD. Give the hotel, guest name and date — we send a photo before delivery.",
    h1: "Flower Delivery to Hotels in Istanbul",
    heroLead: "Can you send flowers to someone staying at a hotel in Istanbul? Yes. We accept orders from any country, deliver the same day, and hand the bouquet over via reception or the concierge. To order, we just need the hotel name, the guest's name and the delivery date.",
    heroBullets: [
      "Same-day hotel delivery (when ordered in time)",
      "Order from abroad: pay by card, crypto or transfer",
      "Hand-over via reception/concierge; photo before delivery",
      "Needed: hotel, guest name, date (room number optional)",
    ],
    cta: "Order Flowers",
    catalogHeading: "Bouquets for hotel delivery — real prices",
    catalogNote: "Tap a bouquet to open it in the catalog. Prices are in US dollars.",
    fullCatalog: "See the full catalog — flower delivery in Istanbul",
    sections: [
      {
        h2: "How Hotel Flower Delivery Works in Istanbul",
        answer: "The process is simple: you choose a bouquet, give the hotel and guest, and we coordinate hand-over with reception.",
        steps: [
          "Choose a bouquet in the catalog or describe your idea on WhatsApp.",
          "Give the name of the hotel in Istanbul.",
          "Give the name of the guest the room is booked under.",
          "Pick the delivery date and a convenient time.",
          "Our florists make the bouquet and send you a photo before dispatch.",
          "The courier hands the bouquet over at the hotel — via reception, concierge or to the guest in person.",
        ],
      },
      {
        h2: "What Information Is Needed?",
        answer: "The more precise the details, the more reliable the hand-over. At minimum: hotel, guest name and date.",
        bullets: [
          "Hotel name",
          "Guest name (in full, as at check-in)",
          "Room number — if known",
          "Delivery date",
          "Preferred delivery time",
          "Recipient phone number",
          "Message for the card",
        ],
        note: "If the room number is unknown, that's fine — the bouquet is handed over at reception using the guest's name. The recipient's phone helps the courier coordinate the hand-over.",
      },
      {
        h2: "Can Flowers Be Delivered Directly to a Hotel Room?",
        answer: "It depends on the individual hotel's policy. Most often the bouquet is handed to reception or the concierge, who notify the guest.",
        paras: [
          "Many hotels don't allow couriers onto the floors for security reasons. In that case reception or the concierge accepts the flowers and either brings them to the room or gives them to the guest on request.",
          "If in-person hand-over matters to you, add the recipient's phone number so the courier can arrange to meet them in the lobby.",
        ],
      },
      {
        h2: "Can I Send Flowers Before Hotel Check-In?",
        answer: "Yes. The bouquet can be timed to the arrival date so it's waiting for the guest at check-in.",
        paras: [
          "Give the arrival date and the hotel name. We coordinate with reception so the flowers are accepted and passed to the guest on check-in.",
          "Note that until actual check-in the hotel keeps the bouquet at reception — choose long-lasting arrangements and add the guest's phone in case the arrival time changes.",
        ],
      },
      {
        h2: "Can I Send Flowers to Someone in Istanbul From Another Country?",
        answer: "Yes. You can order online or on WhatsApp from any country, paying by card, cryptocurrency or transfer.",
        paras: [
          "We communicate in Russian, English and Turkish, so ordering is easy wherever you are. Prices are shown in US dollars.",
          "We send a photo of the finished bouquet before hand-over and confirmation afterwards, so you stay in control of the surprise from a distance.",
        ],
      },
      {
        h2: "Same-Day Flower Delivery to Istanbul Hotels",
        answer: "Same-day delivery is available when ordered in time. The exact timing depends on the area, traffic and holiday demand.",
        paras: [
          "Istanbul is a large city with heavy traffic, and the European and Asian sides are split by the Bosphorus. Allow extra time during rush hours and on public holidays.",
          "To have the bouquet arrive for a specific moment (dinner, check-in, an anniversary), order ahead and specify your preferred delivery window.",
        ],
      },
      {
        h2: "Hotel Flower Delivery Areas in Istanbul",
        answer: "We deliver to hotels on both sides of the Bosphorus — the European and the Asian side.",
        table: {
          head: ["District", "Side", "Delivery information"],
          rows: [
            ["Beşiktaş", "European", "Bosphorus hotels and the business centre — same-day delivery"],
            ["Şişli", "European", "Nişantaşı, business and shopping areas — same-day delivery"],
            ["Beyoğlu", "European", "Taksim, Galata, central hotels — same-day delivery"],
            ["Sultanahmet", "European", "Historic centre, tourist hotels — same-day delivery"],
            ["Sarıyer", "European", "Northern Bosphorus — delivery time confirmed by address"],
            ["Kadıköy", "Asian", "Asian-side hotels — same-day delivery"],
            ["Üsküdar", "Asian", "Asian-side waterfront — delivery time confirmed by address"],
          ],
        },
        note: "Can't find your hotel or area? Send the address on WhatsApp — we'll confirm delivery before you order.",
      },
      {
        h2: "Istanbul Hotels: Areas and Categories",
        answer: "Istanbul's hotels cluster in a few zones, which makes delivery easy to plan.",
        paras: [
          "On the European side that's business-focused Beşiktaş and Levent, upscale Nişantaşı (Şişli), the centre around Taksim and Galata (Beyoğlu), and touristic Sultanahmet. On the Asian side, lively Kadıköy and the waterfront Üsküdar.",
          "We deliver to hotels of every category — from city boutique hotels to large chain complexes and luxury Bosphorus properties. Just give the exact hotel name when you order.",
        ],
      },
      {
        h2: "Flower Delivery to Luxury Hotels in Istanbul",
        answer: "For special occasions, premium bouquets and statement arrangements from our catalog are a great fit.",
        paras: [
          "A romantic surprise, an anniversary, a honeymoon, a marriage proposal or a VIP gift — for these we make premium bouquets, including 101-rose arrangements and signature designs.",
          "Add a card with your message and, if you like, request a photo of the hand-over (subject to the hotel's policy).",
        ],
      },
      {
        h2: "Best Flowers for Different Occasions",
        answer: "Here are simple pointers for occasions and the bouquets that suit them.",
        table: {
          head: ["Occasion", "Recommended flowers", "Bouquet type"],
          rows: [
            ["Birthday", "Bright mixed, roses", "Medium signature bouquet"],
            ["Anniversary", "Red roses", "Medium or premium"],
            ["Honeymoon", "Roses, peony-style", "Premium arrangement"],
            ["Proposal", "101 roses, red roses", "Premium"],
            ["Romantic surprise", "Pastel roses", "Medium"],
            ["Congratulations", "Bright mixed", "Standard/medium"],
            ["Welcome gift", "Soft light tones", "Standard/medium"],
            ["Business gift", "Elegant single-colour, lilies", "Medium/premium"],
            ["Thank you", "Light mixed", "Standard/medium"],
          ],
        },
      },
      {
        h2: "How Much Does Hotel Flower Delivery in Istanbul Cost?",
        answer: "The price depends on the size and make-up of the bouquet. Here are real examples from the catalog (in US dollars).",
        table: {
          head: ["Bouquet", "Price", "Best for"],
          rows: [
            ["Heart's Secret", "$102", "A token of attention, welcome bouquet"],
            ["Blue Lagoon", "$255", "Birthday, congratulations"],
            ["Red Velvet", "$329", "Anniversary, romance"],
            ["Aristocrat Arrangement", "$555", "A statement gift"],
            ["101 Roses", "$707", "A proposal, a special occasion"],
            ["Royal Ball", "$1235", "A VIP surprise, a luxury hotel"],
          ],
        },
        note: "The full range and current prices are in the Istanbul catalog.",
      },
      {
        h2: "What Happens If the Guest Is Not Available?",
        answer: "If the guest isn't available, reception or the concierge usually accepts the bouquet and passes it to the guest.",
        paras: [
          "That's why we recommend adding the recipient's phone number and, where possible, letting the hotel know a delivery is coming. The courier and reception coordinate the hand-over.",
          "If there's any difficulty with the hand-over, we'll contact you to agree on the next steps.",
        ],
      },
      {
        h2: "Tips for Sending Flowers to a Hotel in Istanbul",
        answer: "A few practical tips for a smooth delivery.",
        bullets: [
          "Give the guest's full name, exactly as at check-in.",
          "Write the exact hotel name (Istanbul has similar-sounding ones).",
          "Give the delivery date and preferred time.",
          "If you know the room number, add it.",
          "Leave the recipient's phone to coordinate the hand-over.",
          "If it's a surprise, decide in advance whether to notify the hotel.",
          "Keep check-in and check-out times in mind.",
          "Plan ahead on weekends and public holidays.",
          "Add a card with a personal message.",
          "Allow for traffic between the Asian and European sides.",
        ],
      },
    ],
    faqTitle: "Frequently Asked Questions",
    faq: [
      { q: "Can I send flowers to a hotel in Istanbul?", a: "Yes. Give the hotel name and the guest's name — we coordinate hand-over with reception or the concierge." },
      { q: "Can flowers be delivered to a hotel room?", a: "It depends on the hotel's policy. Usually the bouquet is handed to reception or the concierge, who deliver it to the guest." },
      { q: "Can I order flowers from abroad?", a: "Yes. You can order online or on WhatsApp from any country, paying by card, cryptocurrency or transfer." },
      { q: "Do I need the room number?", a: "Not necessarily. The guest's name is enough — the bouquet is handed over at reception. A known room number speeds things up." },
      { q: "Can flowers arrive before check-in?", a: "Yes. The bouquet can be timed to the arrival date so it's waiting for the guest at check-in." },
      { q: "Do you offer same-day delivery?", a: "Yes, when ordered in time. Timing depends on the area, traffic and holidays." },
      { q: "Can flowers be delivered to hotel reception?", a: "Yes — this is the most common hand-over scenario at hotels." },
      { q: "Can I send flowers anonymously?", a: "Yes, we deliver without revealing the sender and add a card with your message." },
      { q: "Can I add a personal message?", a: "Yes, we attach a card with your message to the bouquet." },
      { q: "Can I choose a delivery time?", a: "Yes, specify your preferred window and we'll aim to deliver within it." },
      { q: "What happens if the guest is not available?", a: "Reception or the concierge usually accepts the bouquet. The recipient's phone helps coordinate the hand-over." },
      { q: "Can I send flowers to a luxury hotel?", a: "Yes. For special occasions, premium bouquets — including 101-rose arrangements — are a great fit." },
      { q: "Can I send flowers to the Asian side of Istanbul?", a: "Yes, we deliver to Asian-side hotels — Kadıköy, Üsküdar and other areas." },
      { q: "Can I send flowers to the European side?", a: "Yes — Beşiktaş, Şişli, Beyoğlu, Sultanahmet, Sarıyer and other areas." },
      { q: "How much does hotel flower delivery cost?", a: "It depends on the bouquet. Catalog examples range from $102 for a compact bouquet up to premium arrangements. Prices are in US dollars." },
      { q: "Will you send a photo of the bouquet before delivery?", a: "Yes, we always send a photo of the finished bouquet before dispatch, and confirmation after hand-over." },
    ],
    glanceTitle: "Istanbul Hotel Flower Delivery at a Glance",
    glance: [
      { label: "Delivery areas", value: "European and Asian sides" },
      { label: "Same-day", value: "Yes, when ordered in time" },
      { label: "International ordering", value: "Yes, from any country" },
      { label: "Hand-over", value: "Via reception or concierge" },
      { label: "Bouquet types", value: "Compact to premium (101 roses)" },
      { label: "Payment", value: "Card, crypto, transfer" },
      { label: "Languages", value: "Russian, English, Turkish" },
      { label: "Card & photo", value: "Personal message + photo before delivery" },
    ],
    relatedTitle: "Related Flower Delivery Services",
    related: related.en,
    breadcrumb: { home: "YUCCA Flowers", city: "Istanbul", current: "Hotel delivery" },
  },

  tr: {
    metaTitle: "İstanbul Otellerine Çiçek Teslimatı — Yurt Dışından Sipariş | YUCCA",
    metaDescription: "İstanbul'da otele çiçek teslimatı: aynı gün, resepsiyon veya concierge aracılığıyla teslim, başka ülkeden sipariş. Fiyatlar USD. Otel, misafir adı ve tarihi belirtin — teslimattan önce fotoğraf gönderiyoruz.",
    h1: "İstanbul Otellerine Çiçek Teslimatı",
    heroLead: "İstanbul'da bir otelde kalan birine çiçek gönderebilir misiniz? Evet. Her ülkeden sipariş alıyoruz, aynı gün teslim ediyoruz ve buketi resepsiyon ya da concierge aracılığıyla teslim ediyoruz. Sipariş için otel adı, misafir adı ve teslim tarihi yeterli.",
    heroBullets: [
      "Otele aynı gün teslimat (zamanında sipariş verildiğinde)",
      "Yurt dışından sipariş: kart, kripto veya havale ile ödeme",
      "Resepsiyon/concierge aracılığıyla teslim; teslimattan önce fotoğraf",
      "Gerekenler: otel, misafir adı, tarih (oda numarası opsiyonel)",
    ],
    cta: "Çiçek Sipariş Ver",
    catalogHeading: "Otele teslimat için buketler — gerçek fiyatlar",
    catalogNote: "Kataloğa açmak için bir bukete dokunun. Fiyatlar ABD doları cinsindendir.",
    fullCatalog: "Tüm kataloğu gör — İstanbul çiçek teslimatı",
    sections: [
      {
        h2: "İstanbul'da Otele Çiçek Teslimatı Nasıl İşler",
        answer: "Süreç basit: bir buket seçersiniz, oteli ve misafiri belirtirsiniz, biz de teslimi resepsiyonla koordine ederiz.",
        steps: [
          "Katalogdan bir buket seçin veya fikrinizi WhatsApp'tan yazın.",
          "İstanbul'daki otelin adını belirtin.",
          "Odanın kayıtlı olduğu misafirin adını belirtin.",
          "Teslim tarihini ve uygun saati seçin.",
          "Çiçekçilerimiz buketi hazırlar ve göndermeden önce size fotoğraf gönderir.",
          "Kurye buketi otelde teslim eder — resepsiyon, concierge veya doğrudan misafire.",
        ],
      },
      {
        h2: "Hangi Bilgiler Gerekli?",
        answer: "Bilgiler ne kadar net olursa teslimat o kadar güvenli olur. En az: otel, misafir adı ve tarih.",
        bullets: [
          "Otel adı",
          "Misafir adı (girişteki gibi tam)",
          "Oda numarası — biliniyorsa",
          "Teslim tarihi",
          "Tercih edilen teslim saati",
          "Alıcının telefon numarası",
          "Kart mesajı",
        ],
        note: "Oda numarası bilinmiyorsa sorun değil — buket, misafirin adıyla resepsiyonda teslim edilir. Alıcının telefonu, kuryenin teslimi koordine etmesine yardımcı olur.",
      },
      {
        h2: "Çiçekler Doğrudan Otel Odasına Teslim Edilebilir mi?",
        answer: "Bu, otelin kurallarına bağlıdır. Çoğunlukla buket resepsiyona veya concierge'e teslim edilir, misafire haber verilir.",
        paras: [
          "Birçok otel güvenlik nedeniyle kuryeleri katlara almaz. Bu durumda çiçekleri resepsiyon ya da concierge teslim alır ve odaya iletir veya talep üzerine misafire verir.",
          "Elden teslim sizin için önemliyse alıcının telefonunu ekleyin; kurye lobide buluşmak için iletişime geçebilir.",
        ],
      },
      {
        h2: "Girişten (Check-in) Önce Çiçek Gönderebilir miyim?",
        answer: "Evet. Buket, giriş tarihine göre ayarlanabilir; böylece check-in sırasında misafiri bekler.",
        paras: [
          "Giriş tarihini ve otel adını belirtin. Çiçeklerin teslim alınıp girişte misafire verilmesi için resepsiyonla koordine ederiz.",
          "Fiili girişe kadar otel buketi resepsiyonda tutar — uzun ömürlü düzenlemeler seçin ve giriş saati değişirse diye misafirin telefonunu ekleyin.",
        ],
      },
      {
        h2: "Başka Bir Ülkeden İstanbul'a Çiçek Gönderebilir miyim?",
        answer: "Evet. Her ülkeden çevrimiçi veya WhatsApp üzerinden sipariş verebilir; kart, kripto para veya havale ile ödeyebilirsiniz.",
        paras: [
          "Rusça, İngilizce ve Türkçe iletişim kuruyoruz, bu yüzden nerede olursanız olun sipariş vermek kolay. Fiyatlar ABD doları cinsindendir.",
          "Teslimden önce hazır buketin fotoğrafını, sonrasında ise teslim onayını gönderiyoruz; sürprizi uzaktan kontrol edebilirsiniz.",
        ],
      },
      {
        h2: "İstanbul Otellerine Aynı Gün Çiçek Teslimatı",
        answer: "Zamanında sipariş verildiğinde aynı gün teslimat mümkündür. Kesin süre bölgeye, trafiğe ve bayram yoğunluğuna bağlıdır.",
        paras: [
          "İstanbul trafiği yoğun büyük bir şehirdir; Avrupa ve Anadolu yakaları Boğaz ile ayrılır. Yoğun saatlerde ve resmi tatillerde ekstra süre bırakın.",
          "Buketin belirli bir ana (akşam yemeği, giriş, yıl dönümü) yetişmesi için önceden sipariş verin ve tercih ettiğiniz teslim aralığını belirtin.",
        ],
      },
      {
        h2: "İstanbul'da Otele Çiçek Teslimat Bölgeleri",
        answer: "Boğaz'ın her iki yakasındaki otellere teslimat yapıyoruz — Avrupa ve Anadolu yakası.",
        table: {
          head: ["Bölge", "Yaka", "Teslimat bilgisi"],
          rows: [
            ["Beşiktaş", "Avrupa", "Boğaz otelleri ve iş merkezi — aynı gün teslimat"],
            ["Şişli", "Avrupa", "Nişantaşı, iş ve alışveriş bölgeleri — aynı gün teslimat"],
            ["Beyoğlu", "Avrupa", "Taksim, Galata, merkez otelleri — aynı gün teslimat"],
            ["Sultanahmet", "Avrupa", "Tarihi merkez, turistik oteller — aynı gün teslimat"],
            ["Sarıyer", "Avrupa", "Boğaz'ın kuzeyi — teslim süresi adrese göre teyit edilir"],
            ["Kadıköy", "Anadolu", "Anadolu yakası otelleri — aynı gün teslimat"],
            ["Üsküdar", "Anadolu", "Anadolu yakası sahili — teslim süresi adrese göre teyit edilir"],
          ],
        },
        note: "Otelinizi veya bölgenizi bulamadınız mı? Adresi WhatsApp'tan yazın — sipariş öncesi teslimatı teyit edelim.",
      },
      {
        h2: "İstanbul Otelleri: Bölgeler ve Kategoriler",
        answer: "İstanbul otelleri birkaç bölgede toplanır; bu da teslimatı planlamayı kolaylaştırır.",
        paras: [
          "Avrupa yakasında iş odaklı Beşiktaş ve Levent, seçkin Nişantaşı (Şişli), Taksim ve Galata çevresindeki merkez (Beyoğlu) ve turistik Sultanahmet. Anadolu yakasında ise hareketli Kadıköy ve sahil kenarındaki Üsküdar.",
          "Her kategoriden otele teslimat yapıyoruz — şehir butik otellerinden büyük zincir komplekslerine ve Boğaz'daki lüks otellere kadar. Sipariş verirken otelin tam adını belirtmeniz yeterli.",
        ],
      },
      {
        h2: "İstanbul'daki Lüks Otellere Çiçek Teslimatı",
        answer: "Özel günler için kataloğumuzdaki premium buketler ve gösterişli düzenlemeler idealdir.",
        paras: [
          "Romantik sürpriz, yıl dönümü, balayı, evlilik teklifi veya VIP hediye — bunlar için 101 gül düzenlemeleri ve özel tasarımlar dahil premium buketler hazırlıyoruz.",
          "Mesajlı bir kart ekleyin ve isterseniz teslim anının fotoğrafını isteyin (otelin kurallarına bağlı olarak).",
        ],
      },
      {
        h2: "Farklı Vesileler İçin En Uygun Çiçekler",
        answer: "Aşağıda vesilelere ve onlara uygun buketlere dair basit ipuçları var.",
        table: {
          head: ["Vesile", "Önerilen çiçekler", "Buket tipi"],
          rows: [
            ["Doğum günü", "Canlı karışık, güller", "Orta boy özel buket"],
            ["Yıl dönümü", "Kırmızı güller", "Orta veya premium"],
            ["Balayı", "Güller, şakayık tarzı", "Premium düzenleme"],
            ["Evlilik teklifi", "101 gül, kırmızı güller", "Premium"],
            ["Romantik sürpriz", "Pastel güller", "Orta"],
            ["Tebrik", "Canlı karışık", "Standart/orta"],
            ["Karşılama hediyesi", "Yumuşak açık tonlar", "Standart/orta"],
            ["İş hediyesi", "Zarif tek renk, zambaklar", "Orta/premium"],
            ["Teşekkür", "Açık renk karışık", "Standart/orta"],
          ],
        },
      },
      {
        h2: "İstanbul'da Otele Çiçek Teslimatı Ne Kadar?",
        answer: "Fiyat buketin boyutuna ve içeriğine bağlıdır. Aşağıda katalogdan gerçek örnekler var (ABD doları cinsinden).",
        table: {
          head: ["Buket", "Fiyat", "Ne için uygun"],
          rows: [
            ["Kalplerin Sırrı", "$102", "İnce bir jest, karşılama buketi"],
            ["Mavi Lagün", "$255", "Doğum günü, tebrik"],
            ["Kırmızı Kadife", "$329", "Yıl dönümü, romantizm"],
            ["Aristokrat Kompozisyon", "$555", "Gösterişli hediye"],
            ["101 Gül", "$707", "Teklif, özel gün"],
            ["Kraliyet Balosu", "$1235", "VIP sürpriz, lüks otel"],
          ],
        },
        note: "Tüm çeşitler ve güncel fiyatlar İstanbul kataloğunda.",
      },
      {
        h2: "Misafir Müsait Değilse Ne Olur?",
        answer: "Misafir müsait değilse buketi genellikle resepsiyon veya concierge teslim alır ve misafire iletir.",
        paras: [
          "Bu yüzden alıcının telefonunu eklemenizi ve mümkünse otele bir teslimat geleceğini bildirmenizi öneririz. Kurye ve resepsiyon teslim anını koordine eder.",
          "Teslimde herhangi bir güçlük olursa, sonraki adımları belirlemek için sizinle iletişime geçeriz.",
        ],
      },
      {
        h2: "İstanbul'da Otele Çiçek Gönderme İpuçları",
        answer: "Teslimatın sorunsuz geçmesi için birkaç pratik öneri.",
        bullets: [
          "Misafirin tam adını, girişteki gibi yazın.",
          "Otelin tam adını yazın (İstanbul'da benzer isimler olabilir).",
          "Teslim tarihini ve tercih edilen saati belirtin.",
          "Oda numarasını biliyorsanız ekleyin.",
          "Teslimi koordine etmek için alıcının telefonunu bırakın.",
          "Sürprizse, oteli önceden bilgilendirip bilgilendirmemeye karar verin.",
          "Giriş ve çıkış saatlerini göz önünde bulundurun.",
          "Hafta sonları ve resmi tatillerde önceden planlayın.",
          "Kişisel mesajlı bir kart ekleyin.",
          "Anadolu ve Avrupa yakaları arası trafik için süre bırakın.",
        ],
      },
    ],
    faqTitle: "Sıkça Sorulan Sorular",
    faq: [
      { q: "İstanbul'da bir otele çiçek gönderebilir miyim?", a: "Evet. Otel adını ve misafirin adını belirtin — teslimi resepsiyon veya concierge ile koordine ederiz." },
      { q: "Çiçekler otel odasına teslim edilebilir mi?", a: "Otelin kurallarına bağlıdır. Genellikle buket resepsiyona ya da concierge'e teslim edilir, onlar da misafire ulaştırır." },
      { q: "Yurt dışından çiçek sipariş edebilir miyim?", a: "Evet. Her ülkeden çevrimiçi veya WhatsApp'tan sipariş verebilir; kart, kripto para veya havale ile ödeyebilirsiniz." },
      { q: "Oda numarası gerekli mi?", a: "Şart değil. Misafirin adı yeterli — buket resepsiyonda teslim edilir. Bilinen oda numarası işi hızlandırır." },
      { q: "Çiçekler girişten önce ulaşabilir mi?", a: "Evet. Buket, giriş tarihine göre ayarlanabilir; check-in sırasında misafiri bekler." },
      { q: "Aynı gün teslimat var mı?", a: "Evet, zamanında sipariş verildiğinde. Süre bölgeye, trafiğe ve bayramlara bağlıdır." },
      { q: "Çiçekler otel resepsiyonuna teslim edilebilir mi?", a: "Evet — otellerde en yaygın teslim şeklidir." },
      { q: "Çiçekleri isimsiz gönderebilir miyim?", a: "Evet, göndereni açıklamadan teslim eder ve mesajınızla bir kart ekleriz." },
      { q: "Kişisel bir mesaj ekleyebilir miyim?", a: "Evet, bukete mesajınızı içeren bir kart iliştiririz." },
      { q: "Teslim saatini seçebilir miyim?", a: "Evet, tercih ettiğiniz aralığı belirtin; o aralıkta teslim etmeye çalışırız." },
      { q: "Misafir müsait değilse ne olur?", a: "Buketi genellikle resepsiyon veya concierge teslim alır. Alıcının telefonu teslimi koordine etmeye yardımcı olur." },
      { q: "Lüks bir otele çiçek gönderebilir miyim?", a: "Evet. Özel günler için 101 gül düzenlemeleri dahil premium buketler idealdir." },
      { q: "İstanbul'un Anadolu yakasına gönderiyor musunuz?", a: "Evet, Anadolu yakası otellerine teslimat yapıyoruz — Kadıköy, Üsküdar ve diğer bölgeler." },
      { q: "Avrupa yakasına gönderiyor musunuz?", a: "Evet — Beşiktaş, Şişli, Beyoğlu, Sultanahmet, Sarıyer ve diğer bölgeler." },
      { q: "Otele çiçek teslimatı ne kadar?", a: "Bukete bağlıdır. Katalog örnekleri kompakt bir buket için $102'den premium düzenlemelere kadar uzanır. Fiyatlar ABD doları cinsindendir." },
      { q: "Teslimattan önce buketin fotoğrafını gönderir misiniz?", a: "Evet, göndermeden önce hazır buketin fotoğrafını, teslimden sonra ise onayı her zaman gönderiyoruz." },
    ],
    glanceTitle: "Kısaca: İstanbul Otel Çiçek Teslimatı",
    glance: [
      { label: "Teslimat bölgeleri", value: "Avrupa ve Anadolu yakası" },
      { label: "Aynı gün", value: "Evet, zamanında sipariş verildiğinde" },
      { label: "Yurt dışından sipariş", value: "Evet, her ülkeden" },
      { label: "Teslim", value: "Resepsiyon veya concierge aracılığıyla" },
      { label: "Buket tipleri", value: "Kompakttan premium'a (101 gül)" },
      { label: "Ödeme", value: "Kart, kripto, havale" },
      { label: "Diller", value: "Rusça, İngilizce, Türkçe" },
      { label: "Kart ve fotoğraf", value: "Kişisel mesaj + teslimattan önce fotoğraf" },
    ],
    relatedTitle: "İlgili Çiçek Teslimat Hizmetleri",
    related: related.tr,
    breadcrumb: { home: "YUCCA Flowers", city: "İstanbul", current: "Otel teslimatı" },
  },
};
